const MOBILE_QUERY = "(width < 1024px)";

class LyleWiyw extends HTMLElement {
  #activeBlockId = null;
  #mobileMediaQuery = null;
  #resizeObserver = null;

  connectedCallback() {
    this.#mobileMediaQuery = window.matchMedia(MOBILE_QUERY);
    this.#mobileMediaQuery.addEventListener(
      "change",
      this.#handleViewportChange,
    );
    this.addEventListener("click", this.#handleClick);

    const list = this.querySelector(".wiyw__list");

    if (list) {
      this.#resizeObserver = new ResizeObserver(() => {
        this.#syncDetailHeights();
      });
      this.#resizeObserver.observe(list);
    }

    for (const image of this.querySelectorAll(".wiyw__featured-media")) {
      if (image.complete) {
        continue;
      }

      image.addEventListener(
        "load",
        () => {
          this.#syncDetailHeights();
        },
        { once: true },
      );
    }

    this.#syncView();
  }

  disconnectedCallback() {
    this.#mobileMediaQuery?.removeEventListener(
      "change",
      this.#handleViewportChange,
    );
    this.#mobileMediaQuery = null;
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
    this.removeEventListener("click", this.#handleClick);
  }

  #handleViewportChange = () => {
    if (!this.#mobileMediaQuery?.matches) {
      this.#activeBlockId = null;
    }

    this.#syncView();
  };

  #handleClick = (event) => {
    const toggle = event.target.closest("[data-wiyw-toggle]");

    if (!toggle) {
      return;
    }

    event.preventDefault();
    this.#toggleDetailView(toggle.dataset.blockId);
  };

  #toggleDetailView(blockId) {
    if (this.#activeBlockId === blockId) {
      this.#activeBlockId = null;
    } else {
      this.#activeBlockId = blockId;
    }

    this.#syncView();
  }

  #syncDetailHeights() {
    const isMobile = this.#mobileMediaQuery?.matches ?? false;

    for (const block of this.querySelectorAll("[data-wiyw-block]")) {
      const detail = block.querySelector(".wiyw__item-detail");

      if (!detail) {
        continue;
      }

      if (isMobile || !block.classList.contains("is-active")) {
        detail.style.removeProperty("--wiyw-detail-height");
        continue;
      }

      const thumbnail = block.querySelector(".wiyw__item");

      if (!thumbnail) {
        detail.style.removeProperty("--wiyw-detail-height");
        continue;
      }

      detail.style.setProperty(
        "--wiyw-detail-height",
        `${thumbnail.offsetHeight}px`,
      );
    }
  }

  #syncView() {
    const showLabel = this.dataset.showLabel ?? "Show details";
    const hideLabel = this.dataset.hideLabel ?? "Hide details";

    for (const block of this.querySelectorAll("[data-wiyw-block]")) {
      const blockId = block.dataset.wiywBlock;
      const isActive = blockId === this.#activeBlockId;

      block.classList.toggle("is-active", isActive);

      const detailContent = block.querySelector("[data-wiyw-detail-content]");

      if (detailContent) {
        detailContent.classList.toggle("is-open", isActive);
      }

      for (const toggle of block.querySelectorAll("[data-wiyw-toggle]")) {
        const label = toggle.querySelector("[data-wiyw-toggle-label]");

        if (label) {
          label.textContent = isActive ? hideLabel : showLabel;
        }
      }
    }

    this.#syncDetailHeights();
    requestAnimationFrame(() => {
      this.#syncDetailHeights();
    });
  }
}

if (!customElements.get("lyle-wiyw")) {
  customElements.define("lyle-wiyw", LyleWiyw);
}
